/**
 * On the web we only render focused pages, so anything being rendered is
 * "focused".
 */
export function useIsFocused(): boolean {
  return true
}
